import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export class PaymentRepository {
    // 정산 내역 생성
    static onPostCreatePayment = (meetingId: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('payments')}/${meetingId}/payments`,
            method: RequestMethod.POST,
            params
        })
    }

    // 정산 목록 조회
    static onGetPayments = (meetingId: string) => {
        return onRequest({
            url: `${getApiUrl('payments')}/${meetingId}/payments`,
            method: RequestMethod.GET
        })
    }

    // 정산 상세 조회
    static onGetPaymentDetail = (paymentId: string) => {
        return onRequest({
            url: `${getApiUrl('paymentDetail')}/${paymentId}`,
            method: RequestMethod.GET
        })
    }

    // 정산 요청 (현재 API에 없음 - 나중에 구현 필요)
    static onPostRequestPayment = (paymentId: string, params?: any) => {
        return onRequest({
            url: `${getApiUrl('paymentRequest')}/${paymentId}/request`,
            method: RequestMethod.POST,
            params
        })
    }

    // 정산 완료
    static onPostCompletePayment = (paymentId: string, params?: any) => {
        return onRequest({
            url: `${getApiUrl('paymentComplete')}/${paymentId}/complete`,
            method: RequestMethod.POST,
            params
        })
    }

    // 영수증 OCR
    static onPostReceiptOcr = (meetingId: string, formData: FormData) => {
        return onRequest({
            url: `${getApiUrl('receiptOcr')}/${meetingId}/payments/receipt/ocr`,
            method: RequestMethod.POST,
            params: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
